import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AiAgentsGlobalService } from '@core/services/store/ai-agents-global.service';
import { AIAgent } from '@features/ai-agents/ai-agent.types';

export const aiAgentsResolver: ResolveFn<AIAgent[]> = () => {
    const aiAgentsS = inject(AiAgentsGlobalService);

    if (!aiAgentsS.aiAgents().length) {
        return aiAgentsS.getAllAndStore$();
    } else {
        return aiAgentsS.aiAgents();
    }
};
